import React, { useEffect, useState } from "react";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import { FaCopy } from "react-icons/fa";
import radioImg from "../images/afro-radio.gif";
// import radioImg2 from "../images/afro-radio-white.jpeg";
// import radioImg3 from "../images/afro-radio-2.jpeg";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import play from "../images/play.gif";
import rightIcon from "../images/right-icon.gif";
import shareIcon from "../images/share-icon.gif";
import Navbar from "./navbar";

import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { IMAGE_BASE_URL } from "../data/baseURL";
// import bgVideo from "../videos/bg-video.mp4";

const Header = ({
  children,
  bannerBackground,
  imageURL,
  videoURL,
  staticImageURL,
}) => {
  const [isFixed, setIsFixed] = useState(false);
  const [visible, setVisible] = useState(false);

  window.addEventListener("scroll", () => {
    if (window.scrollY > window.innerHeight) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  });

  useEffect(() => {
    const body = document.body;
    let topPosition = 0;
    function handleNavbar() {
      const currentScroll = window.pageYOffset;

      if (currentScroll <= 0) {
        body.classList.remove("scroll-up");
      }
      if (
        currentScroll > topPosition &&
        !body.classList.contains("scroll-down")
      ) {
        body.classList.remove("scroll-up");
        body.classList.add("scroll-down");
      }
      if (
        currentScroll < topPosition &&
        body.classList.contains("scroll-down")
      ) {
        body.classList.remove("scroll-down");
        body.classList.add("scroll-up");
      }

      topPosition = currentScroll;
    }

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleNavbar);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleNavbar);
      }
    };
  }, []);

  return (
    <header>
      {bannerBackground === "video" ? (
        <VideoBanner videoURL={videoURL}>{children}</VideoBanner>
      ) : (
        <ImageBanner imageURL={imageURL} staticImageURL={staticImageURL}>
          {children}
        </ImageBanner>
      )}

      <section
        className={`${isFixed ? `position-fixed d-block` : "d-none"}`}
        style={{
          transition: "all 0.6s ease-out",
          zIndex: "1000",
          bottom: "6rem",
          right: "6rem",
          borderRadius: "50rem",
          color: "orange",
        }}
      >
        <span
          className="cursor-pointer"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <BsFillArrowUpCircleFill size={40} />
        </span>
      </section>

      <section className="position-fixed afro-radio-section d-none d-lg-block">
        <div
          className={`position-relative afro-radio-section-2 ${
            !visible ? "d-inline" : "d-block"
          }`}
        >
          <div
            className="position-relative d-inline-block"
            style={{ zIndex: "1" }}
          >
            <img src={radioImg} className="afro-radio-logo" alt="" />
            <div className="position-absolute top-0 text-white d-flex justify-content-between flex-column h-100 fs-18 afro-radio-section-4">
              <p onClick={() => setVisible(true)}>
                <img src={play} className="cursor-pointer" alt="" />
              </p>
              <p data-bs-toggle="modal" data-bs-target="#copyandshare">
                <img src={shareIcon} className="cursor-pointer" alt="" />
              </p>
              <p onClick={() => setVisible(false)}>
                <img src={rightIcon} className="cursor-pointer" alt="" />
              </p>
            </div>
          </div>
          <div
            className={`position-absolute top-0 bottom-0 afro-radio-section-3 ${
              visible
                ? "afro-radio-section-3-active"
                : "afro-radio-section-3-inactive"
            }`}
          >
            <div className="bg-white shadow p-4 rounded-3">
              <iframe
                src="https://radio.afro-group.com/public/afro_radio/embed"
                frameborder="0"
                allowTransparency="false"
                className="radio-frame"
                title="Afro Radio"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="position-fixed afro-radio-section d-block d-lg-none">
        <span
          className="cursor-pointer"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          <img src={radioImg} className="afro-radio-logo" alt="" />
        </span>
      </section>

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title fs-22 gilroy-bold"
                id="staticBackdropLabel"
              >
                Afro Radio
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="p-4">
                <iframe
                  src="https://radio.afro-group.com/public/afro_radio/embed"
                  frameborder="0"
                  allowTransparency="false"
                  style={{
                    width: "100%",
                    minHeight: "150px",
                    border: "0",
                    color: "black",
                  }}
                  title="Afro Radio"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger px-4 text-white fs-16"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="copyandshare"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="copyandshareLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title fs-22 gilroy-bold"
                id="copyandshareLabel"
              >
                Afro Radio Share
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <div className="my-4">
                  <FacebookShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <FacebookIcon size={32} className="mx-2" round />
                  </FacebookShareButton>

                  <FacebookMessengerShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <FacebookMessengerIcon size={32} className="mx-2" round />
                  </FacebookMessengerShareButton>

                  <LinkedinShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <LinkedinIcon size={32} className="mx-2" round />
                  </LinkedinShareButton>

                  <WhatsappShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <WhatsappIcon size={32} className="mx-2" round />
                  </WhatsappShareButton>

                  <InstapaperShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <InstapaperIcon size={32} className="mx-2" round />
                  </InstapaperShareButton>

                  <EmailShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <EmailIcon size={32} className="mx-2" round />
                  </EmailShareButton>

                  <TwitterShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <TwitterIcon size={32} className="mx-2" round />
                  </TwitterShareButton>

                  <PinterestShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <PinterestIcon size={32} className="mx-2" round />
                  </PinterestShareButton>

                  <RedditShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <RedditIcon size={32} className="mx-2" round />
                  </RedditShareButton>

                  <TumblrShareButton
                    url={`https://radio.afro-group.com/public/afro_radio`}
                  >
                    <TumblrIcon size={32} className="mx-2" round />
                  </TumblrShareButton>
                </div>
                <CopyToClipboard
                  text="https://radio.afro-group.com/public/afro_radio"
                  style={{ fontSize: "16px" }}
                  onCopy={() => toast.success("Copied")}
                >
                  <div className="block bg-gray-200 border rounded-md">
                    <div className="d-flex justify-content-between align-items-center cursor-pointer px-4">
                      <h6 className="px-1 my-4 fw-bold">
                        https://radio.afro-group.com/public/afro_radio
                      </h6>
                      <FaCopy size={24} className="text-green-500" />
                    </div>
                  </div>
                </CopyToClipboard>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger px-4 text-white fs-16"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

function VideoBanner({ videoURL, children }) {
  return (
    <section className="header-container text-white position-relative">
      <div className="bg-video">
        <video className="bg-video__content" autoPlay muted loop>
          <source src={`${IMAGE_BASE_URL}/${videoURL}`} type="video/mp4" />
          your browser is not supported!
        </video>
      </div>
      <div className="linear-style">
        <div className="pb-7">
          <Navbar />
        </div>
        <div className="pt-5 pt-md-0 pb-7">{children}</div>
      </div>
    </section>
  );
}

function ImageBanner({ imageURL, children, staticImageURL }) {
  const url = staticImageURL
    ? `${staticImageURL}`
    : `${IMAGE_BASE_URL}/${imageURL}`;
  return (
    <section
      className="header-container text-white"
      style={{
        backgroundImage: `url(${url})`,
      }}
    >
      <div className="linear-style">
        <div className="pb-7">
          <Navbar />
        </div>
        <div className="pt-5 pt-md-0 pb-7">{children}</div>
      </div>
    </section>
  );
}

export default Header;
